import { StyledCheckboxContainer } from './CheckboxWithTooltip.styled';
import { Checkbox } from '../../atoms/Checkbox';
import { StyledLabel } from '../../atoms/Label';
import { Tooltip } from '../../atoms/Tooltip';
import { TooltipInfo } from '../../svgs';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A molecule combining the `Checkbox`, `StyledLabel`, and `Tooltip` atoms.
 * Use the optional `label` to add a label, `labelProps`, `tooltipProps` and `checkboxProps` to pass props onto these atoms.
 * Note, the `text` parameter in `tooltipProps` sets the tooltip text. All native HTML checkbox behaviors are supported.
 *
 * **Internal-only component!**
 * - Common styling per the design system for shape and layout.
 * - No custom behavior beyond the HTML element's native behavior.
 * - No custom props.
 */
export const CheckboxWithTooltip = ({
  id,
  label,
  labelProps,
  tooltipText,
  tooltipProps,
  checkboxProps
}) => /*#__PURE__*/_jsxs(StyledCheckboxContainer, {
  children: [/*#__PURE__*/_jsx(Checkbox, {
    id: id,
    ...checkboxProps
  }), /*#__PURE__*/_jsx(StyledLabel, {
    htmlFor: id,
    ...labelProps,
    children: label
  }), /*#__PURE__*/_jsxs(Tooltip, {
    text: tooltipText,
    ...tooltipProps,
    children: [/*#__PURE__*/_jsx(TooltipInfo, {}), ' ']
  })]
});